import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../core/services/data.service';
import { wrapLinks } from 'src/util';
import { I18NextService } from 'angular-i18next';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
})
export class ImprintComponent implements OnInit {
  imprintTxt!: any;

  constructor(
    private dataService: DataService,
    private i18NextService: I18NextService
  ) {}

  ngOnInit(): void {
    this.dataService.legals$.subscribe((legals) => {
      this.imprintTxt = {
        ...legals,
        imprint_content: wrapLinks(
          this.i18NextService.t(legals.imprint_content)
        ),
      };
    });
  }
}
